import { Div, Icon, Label, Loader } from "@grassrootly/rn-core";
import { ScreenLayout } from "../../layout/components";
import { MainStackScreenProps } from "../../navigation/Navigation.types";
import { useGameScreen } from "./useGame";
import GamePreview from "../../common/game/GamePreview";

export default function GameScreen({ navigation, route }: MainStackScreenProps<"game">) {
  const { game, loading } = useGameScreen(route.params.id);
  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
      return;
    }
    navigation.navigate("home");
  };
  return (
    <ScreenLayout
      header={{
        center: `GAME`,
        left: <Icon name="arrow_back_ios" size={24} onPress={goBack} classNames={["mb-{5}"]} />,
      }}
    >
      {game ? <GamePreview game={game} /> : null}
      {!game ? (
        <Div classNames={["flex1", "alignContentCenter", "mt-{30}"]}>
          {loading ? (
            <Loader size="large" isLoading />
          ) : (
            <Label type="l1Bold" classNames={["textCenter", "colorSecondaryLight"]}>
              Game not found
            </Label>
          )}
        </Div>
      ) : null}
    </ScreenLayout>
  );
}
